'use strict';

function PwCheckDirective() {
  return {
    require: 'ngModel',
    link: function($scope, elem, attrs, ctrl) {
      var firstPassword = '#' + attrs.pwCheck;
      elem.add(firstPassword).on('keyup', function () {
        $scope.$apply(function () {
          var v = elem.val() === $(firstPassword).val();
          ctrl.$setValidity('pwmatch', v);
        });
      });
    }
  };
}

angular.module('dokiv')
  .directive('pwCheck', [PwCheckDirective]);



//////////////////
// WEBPACK FOOTER
// ./scripts/user/PwCheckDirective.js
// module id = 434
// module chunks = 0